<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  {{description}}
  <br>
  <br>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" *ngIf="data.appointment.hoursBeforeAppointment<=24" (click)="onNoClick()">Close</button>
  <button mat-raised-button color="primary" *ngIf="data.appointment.hoursBeforeAppointment>24" (click)="onNoClick()">No</button>
  <button mat-raised-button color="primary" *ngIf="data.appointment.hoursBeforeAppointment>24" (click)="onYesClick()" cdkFocusInitial>{{confirmText}}</button>
</div>